module.exports = __webpack_public_path__ + "static/img/6.10eab34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/6.png
// module id = rWNC
// module chunks = 0